/* HTTP service */

import axios from "axios";
import Settings from "./settings.service";
import GTMService from "./gtm.service";
import Errors from "./errors.service";
import Translation from "./translation.service";
import Storage from "./storage.service";

var rand = Math.floor(Math.random() * 10000000000 + 1);

var device = rand;

var session_id = "";

const HTTP = axios.create({
	baseURL: Settings.base_url,
	headers: {
		"accept-version": Settings.api_version,
		"Virgin-Lang": "en",
		"ChannelID": "Web",
		"Channel-Id": "Web",
		"Virgin-Device-Id": device,
		"Virgin-Device-Os": "Web"
	}
});

HTTP.defaults.headers.common["Accept"] = "application/json";

HTTP.defaults.headers.post["Content-Type"] =
	"application/x-www-form-urlencoded";

// HTTP.interceptors.request.use(
// 	config => {
// 		config.headers["Virgin-Lang"] = Translation.activeLang;
// 		if (config.baseURL === Settings.base_url) {
// 			config.headers["Virgin-Device-Id"] = device;
// 			if (session_id) {
// 				config.headers["Session-Id"] = session_id;
// 			}
// 		}
// 		return config;
// 	},
// 	error => Promise.reject(error)
// );

HTTP.interceptors.request.use(
	config => {
		config.headers["Virgin-Lang"] = Translation.activeLang;
		if (Settings.version === "_kw_onboard") {
			config.headers["Virgin-Brand"] = "virgin"
		}
		if (config.baseURL === Settings.base_url) {
			config.headers["Virgin-Device-Id"] = device;
			if (session_id) {
				config.headers["Session-Id"] = session_id;
			}
			// Override Lokalise: Added to handle same lokalise api on staging & production
			if (config.url.includes("/translations/lokalize")) {
				config.baseURL = Settings.lokalise_url;
			}
		}
		return config;
	},
	error => Promise.reject(error)
);

HTTP.interceptors.response.use(undefined, function (error) {
	let inSimDeactivationStep = Storage.get("sim_deactivation_step", true);
	if (!inSimDeactivationStep) {
		Errors.handleError(error);
	}
	GTMService.general_error();
	throw error;
});

HTTP.generate_device_id = () => {
	return Math.floor(Math.random() * 10000000000 + 1);
};

HTTP.get_device_id = () => {
	return device;
};

HTTP.set_device_id = val => {
	device = val;
};

HTTP.set_session = val => {
	session_id = val;
};

export default HTTP;